export function isEmbeddedInFrame(currentWindow: Window = window): boolean {
  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    // Browsers throw on reading a cross-origin parent, which only happens inside a frame.
    return true;
  }
}
